import { useNavigate } from "react-router-dom";
import { CalendarDays, Sprout, Wheat } from "lucide-react";

const FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const norm = (a) => (Array.isArray(a) ? a.map(Number).filter((m) => m >= 1 && m <= 12) : []);

function collect(fields, month) {
  return fields.map((f) => {
    const crops = f.analysis?.crops || [];
    const sow = crops.filter((c) => norm(c.calendar?.sow_months).includes(month)).map((c) => c.name);
    const harvest = crops.filter((c) => norm(c.calendar?.harvest_months).includes(month)).map((c) => c.name);
    return { id: f.id, name: f.name, sow, harvest };
  }).filter((x) => x.sow.length || x.harvest.length);
}

function MonthCard({ label, month, items, accent }) {
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-5" data-testid={`reminder-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs uppercase tracking-wider text-stone-500 font-semibold">{label}</span>
        <span className="font-display font-bold" style={{ color: accent }}>{FULL[month - 1]}</span>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-stone-400">Nothing scheduled — a quiet month for your saved fields.</p>
      ) : (
        <ul className="space-y-2.5">
          {items.map((it) => (
            <li key={it.id} className="text-sm">
              <div className="font-semibold text-emerald-950">{it.name}</div>
              {it.sow.length > 0 && <div className="flex items-start gap-1.5 text-stone-600"><Sprout className="h-4 w-4 text-[#D97706] shrink-0 mt-0.5" /><span><b className="text-[#D97706]">Sow:</b> {it.sow.join(", ")}</span></div>}
              {it.harvest.length > 0 && <div className="flex items-start gap-1.5 text-stone-600"><Wheat className="h-4 w-4 text-[#2D6A4F] shrink-0 mt-0.5" /><span><b className="text-[#2D6A4F]">Harvest:</b> {it.harvest.join(", ")}</span></div>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function SowingReminders({ fields }) {
  const navigate = useNavigate();
  const hasCalendar = fields.some((f) => (f.analysis?.crops || []).some((c) => c.calendar));
  if (!hasCalendar) return null;
  const now = new Date().getMonth() + 1;
  const next = (now % 12) + 1;

  return (
    <div className="mb-8" data-testid="sowing-reminders">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-2xl font-bold text-emerald-900 flex items-center gap-2"><CalendarDays className="h-6 w-6 text-[#D97706]" /> On your farm calendar</h2>
        <button onClick={() => navigate("/app/fields")} className="text-sm font-semibold text-[#2D6A4F] hover:underline">See all fields</button>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <MonthCard label="This month" month={now} items={collect(fields, now)} accent="#D97706" />
        <MonthCard label="Next month" month={next} items={collect(fields, next)} accent="#2D6A4F" />
      </div>
    </div>
  );
}
